// Merkan · Englisches Wörterbuch: Postfach unter Service Hub, Markierungen, Wichtig, Zurückstellen
export default {
  'Postfach': 'Mailbox',
  'Postfächer': 'Mailboxes',
  'Neue Mail': 'New email',
  'Vertretung': 'Delegate',
  'Mails': 'Emails',
  'Betreff, Absender oder Markierung': 'Subject, sender or label',
  'Offen': 'Open',
  'Verarbeitet': 'Processed',
  'Alles bearbeitet': 'All done',
  'Keine Mails': 'No emails',
  'Neue Mails erscheinen hier automatisch.': 'New emails appear here automatically.',
  'Noch nichts verarbeitet.': 'Nothing processed yet.',
  'im Service Hub': 'in Service Hub',
  'erledigt': 'done',
  'Keine Mail gewählt': 'No email selected',
  'Wähle links eine Mail. Zuordnen, Vorgang anlegen oder in den Service Hub übernehmen geht direkt aus der Mail.': 'Pick an email on the left. Assign, create a case or move it to the Service Hub right from the email.',
  'Kein persönliches Postfach': 'No personal mailbox',
  'Verbinde dein eigenes Postfach. Mails daraus erscheinen hier und erst nach Übernahme im Service Hub.': 'Connect your own mailbox. Its emails appear here and only reach the Service Hub once you move them there.',
  'Mein Postfach verbinden': 'Connect my mailbox',
  '{n} ungelesen': '{n} unread',
  'Wichtig': 'Important',
  'Als wichtig markiert': 'Marked as important',
  'Nicht mehr wichtig': 'No longer important',
  'Zurückstellen': 'Snooze',
  'Zurückgestellt': 'Snoozed',
  'Zurückgestellt bis {zeit}': 'Snoozed until {zeit}',
  'Nicht mehr zurückgestellt': 'No longer snoozed',
  'Zurückstellen aufheben': 'Remove snooze',
  'Heute 17:00': 'Today 5 pm',
  'Morgen 8:00': 'Tomorrow 8 am',
  'Montag 8:00': 'Monday 8 am',
  'In einer Woche': 'In a week',
  'Datum und Uhrzeit': 'Date and time',
  'Setzen': 'Set',
  'Markieren': 'Label',
  'Markierungen ({n})': 'Labels ({n})',
  'Markierungen gespeichert': 'Labels saved',
  'Noch keine Markierungen. Anlegen unter Einstellungen, Markierungen.': 'No labels yet. Create them under Settings, Labels.',
  'In Service Hub': 'To Service Hub',
  'In den Service Hub übernommen. Die Mail wird im Postfach nach „In Merkan verarbeitet“ verschoben.': 'Moved to the Service Hub. The email is moved to “In Merkan verarbeitet” in the mailbox.',
  'Erledigt': 'Done',
  'Erledigt. Die Mail wird im Postfach nach „In Merkan verarbeitet“ verschoben.': 'Done. The email is moved to “In Merkan verarbeitet” in the mailbox.',
  'Spam': 'Spam',
  'Als Spam markiert und in den Junk-Ordner verschoben.': 'Marked as spam and moved to the junk folder.',
  'Löschen': 'Delete',
  'Gelöscht. Die Mail liegt im Papierkorb des Postfachs.': 'Deleted. The email is in the mailbox trash.',
  'Postfach: {fehler}': 'Mailbox: {fehler}',
  'Nachricht bearbeiten': 'Edit message',
  'Markierung': 'Label',
  'Markierungen': 'Labels',
  'Alle Markierungen': 'All labels',
  'Eigene Markierungen mit Farbe für Service Hub und Postfach. Sie gelten für das ganze Team und lassen sich filtern und suchen. Wichtig und Zurückstellen gibt es immer.': 'Custom coloured labels for the Service Hub and mailbox. They apply to the whole team and can be filtered and searched. Important and snooze are always available.',
  'z. B. Rückruf, Reklamation, Privat': 'e.g. Call back, Complaint, Private',
  'Farbe': 'Colour',
  'Anlegen': 'Create',
  'Vorschau': 'Preview',
  'Markierung angelegt': 'Label created',
  'Markierung gelöscht': 'Label deleted',
  'Die Markierung {name} gibt es schon.': 'The label {name} already exists.',
  'Markierung {name} löschen?': 'Delete label {name}?',
  'Sie verschwindet von allen Nachrichten. Die Nachrichten selbst bleiben.': 'It is removed from all messages. The messages themselves stay.',
  'Noch keine Markierungen': 'No labels yet',
  'Lege oben die erste an.': 'Create the first one above.',
  'Nach oben': 'Move up',
  'Nach unten': 'Move down',
  'Blau': 'Blue', 'Grün': 'Green', 'Orange': 'Orange', 'Rot': 'Red', 'Petrol': 'Teal', 'Grau': 'Grey',
  'Abruf ohne Änderung.': 'Fetching changes nothing.',
  'Merkan liest über Microsoft Graph. Beim Abruf wird nichts verschoben und nichts als gelesen markiert.': 'Merkan reads via Microsoft Graph. Fetching moves nothing and marks nothing as read.',
  'Merkan holt Mails schreibgeschützt (IMAP EXAMINE, BODY.PEEK). Beim Abruf wird nichts verschoben und nichts als gelesen markiert.': 'Merkan fetches read only (IMAP EXAMINE, BODY.PEEK). Fetching moves nothing and marks nothing as read.',
  'Nach der Bearbeitung:': 'After processing:',
  'Wird eine Mail einem Vorgang zugeordnet, daraus ein Vorgang angelegt, erledigt oder in den Service Hub übernommen, verschiebt Merkan sie im Postfach in den Ordner „In Merkan verarbeitet“. Merkan legt den Ordner beim Verbindungstest an.': 'When an email is assigned to a case, turned into a case, marked done or moved to the Service Hub, Merkan moves it to the folder “In Merkan verarbeitet” in the mailbox. Merkan creates the folder during the connection test.',
  'Spam verschiebt in den Junk-Ordner, Löschen in den Papierkorb. Endgültig gelöscht wird nichts.': 'Spam moves to the junk folder, delete moves to the trash. Nothing is deleted permanently.',
  '„Gelesen“, Markierungen, Wichtig und Zurückstellen wirken nur in Merkan, nicht im Postfach.': '“Read”, labels, important and snooze apply only in Merkan, not in the mailbox.',
  'Mails, die aus Merkan gesendet werden, legt Merkan als gelesene Kopie im Gesendet-Ordner ab.': 'Emails sent from Merkan are stored as a read copy in the sent folder.',
  'Mails aus Merkan legt {anbieter} beim Versand selbst im Gesendet-Ordner ab.': '{anbieter} stores emails sent from Merkan in the sent folder itself.',
  // Assistent „Postfach verbinden“
  'Postfach verbinden': 'Connect mailbox',
  'Dein Postfach verbinden': 'Connect your mailbox',
  'In drei Schritten, wie am iPhone': 'In three steps, just like on an iPhone',
  'Gib die E-Mail-Adresse ein. Merkan erkennt den Anbieter und richtet alles ein.': 'Enter the email address. Merkan detects the provider and sets everything up.',
  'name@firma.de': 'name@company.com',
  'Anbieter nicht sicher erkannt': 'Provider not detected for sure',
  'erkannt, weiter mit Enter': 'detected, press Enter to continue',
  'oder Anbieter wählen': 'or choose a provider',
  'Anbieter suchen': 'Search providers',
  'Weitere Anbieter': 'More providers',
  'IMAP und SMTP, Merkan versucht die Einstellungen selbst': 'IMAP and SMTP, Merkan tries the settings itself',
  'Zurück': 'Back',
  'Anmeldung über Microsoft, ohne Passwort in Merkan': 'Sign-in through Microsoft, no password in Merkan',
  'Anmeldung mit {kennwort}': 'Sign-in with {kennwort}',
  'Für wen?': 'For whom?',
  'Für mich': 'For me',
  'Für jemand anderen': 'For someone else',
  'Für Shared Mailboxes wie info@: Du meldest dich mit deinem eigenen Konto an, das Vollzugriff darauf hat. Mails erscheinen im Service Hub.': 'For shared mailboxes like info@: sign in with your own account that has full access. Emails appear in the Service Hub.',
  'Für Adressen wie info@. Mails erscheinen im Service Hub.': 'For addresses like info@. Emails appear in the Service Hub.',
  'Persönliches Postfach. Mails erscheinen unter Postfach, nicht automatisch im Service Hub.': 'Personal mailbox. Emails appear under Mailbox, not automatically in the Service Hub.',
  'App-Passwort erzeugen': 'Create app password',
  'Servereinstellungen': 'Server settings',
  'So sehen Empfänger den Absender': 'How recipients see the sender',
  'Einen Moment …': 'One moment …',
  'Verbinden': 'Connect',
  'Merkan meldet sich am Postfach an und legt den Ordner „In Merkan verarbeitet“ an.': 'Merkan signs in to the mailbox and creates the folder “In Merkan verarbeitet”.',
  'Verbunden': 'Connected',
  '{n} Mails im Posteingang': '{n} emails in the inbox',
  'Sammelpostfach, erscheint im Service Hub': 'Shared mailbox, appears in the Service Hub',
  'Persönliches Postfach, erscheint unter Postfach': 'Personal mailbox, appears under Mailbox',
  'Ordner „In Merkan verarbeitet“ ist angelegt': 'Folder “In Merkan verarbeitet” is created',
  'Der erste Abruf holt die letzten 30 Tage, danach alle 2 Minuten': 'The first fetch gets the last 30 days, then every 2 minutes',
  'Fertig': 'Done',
  'Die Adresse {adresse} ist schon eingebunden.': 'The address {adresse} is already connected.',
  'Zustimmung erteilt. Jetzt erneut „Mit Microsoft anmelden“ wählen.': 'Consent granted. Now choose “Sign in with Microsoft” again.',
  'Verbinde das Sammelpostfach, damit eingehende Mails im Service Hub erscheinen.': 'Connect the shared mailbox so incoming emails appear in the Service Hub.',
  'Sammelpostfächer wie info@ erscheinen im Service Hub, persönliche Postfächer unter Postfach. Abruf alle 2 Minuten, bearbeitete Mails legt Merkan im Postfach in „In Merkan verarbeitet“ ab. Zugangsdaten liegen verschlüsselt im Tresor.': 'Shared mailboxes like info@ appear in the Service Hub, personal mailboxes under Mailbox. Fetched every 2 minutes; processed emails are filed in “In Merkan verarbeitet”. Credentials are stored encrypted in the vault.',
  // Entwürfe, Verlauf, Inhaber
  'Entwurf': 'Draft',
  'Entwurf gespeichert': 'Draft saved',
  'Entwurf verwerfen': 'Discard draft',
  'Entwurf fortsetzen': 'Continue draft',
  '{n} Nachricht im Verlauf': '{n} message in the thread',
  '{n} Nachrichten im Verlauf': '{n} messages in the thread',
  'Alle aufklappen': 'Expand all',
  'Alle einklappen': 'Collapse all',
  'Wird Sammelpostfach im Service Hub. Du meldest dich mit deinem eigenen Konto an, das Zugriff darauf hat.': 'Becomes a shared mailbox in the Service Hub. Sign in with your own account that has access to it.',
  'Wird Sammelpostfach im Service Hub.': 'Becomes a shared mailbox in the Service Hub.',
  'Wird dein persönliches Postfach unter Postfach.': 'Becomes your personal mailbox under Mailbox.',
  'angemeldet als {konto}': 'signed in as {konto}',
} satisfies Record<string, string>;
